import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import dayjs from 'dayjs'

import { api } from '../adminApi'
import { GetStoreUploadResponse } from '../generated/api'

interface DataTableOptions {
  page: number,
  itemsPerPage: number,
  sortBy: string[],
  sortDesc: boolean[],
  groupBy: string[],
  groupDesc: boolean[],
  multiSort: boolean,
  mustSort: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreUploadList',
  props: {
    store: null
  },
  setup(__props: any) {

const props = __props as {
  store: string,
}




const headers = [
{
    text: "Upload ID",
    value: "uploadId",
  },
  {
    text: "Description",
    value: "description",
  },
  {
    text: "Build ID",
    value: "buildId",
  },
  {
    text: "Uploaded at",
    value: "uploadTimestamp",
  },
  {
    text: "Expired at",
    value: "expiryTimestamp",
  },
  {
    text: "Status",
    value: "status",
  }
]

let options: DataTableOptions = {
  page: 1,
  itemsPerPage: 25,
  sortBy: [],
  sortDesc: [],
  groupBy: [],
  groupDesc: [],
  multiSort: false,
  mustSort: false,
}

const storeUploads = ref([] as GetStoreUploadResponse[])
const total = ref(1)

function timestampToDisplayString(timestamp: string): string {
  return dayjs(timestamp).format('YYYY-MM-DD HH:mm')
}

function getSortIndex(): string | undefined {
  if (options.sortBy.length == 0) {
    return undefined
  } else {
    const sortDirection = (options.sortDesc[0] ? "-" : "")
    const sortKey = options.sortBy[0]
    return `${sortDirection}${sortKey}`
  }
}

async function fetch() {

  try {
    const storeUploadsResponse = await api.getStoreUploads(props.store, getSortIndex(), (options.page - 1) * options.itemsPerPage, options.itemsPerPage)
    storeUploads.value = storeUploadsResponse.data.uploads
    total.value = storeUploadsResponse.data.pagination.total
  } catch (error) {
    console.log(error)
  }
}

function updateOptions(newOptions: DataTableOptions) {
  if ((options.page != newOptions.page)
    || (options.itemsPerPage != newOptions.itemsPerPage)
    || (options.sortBy != newOptions.sortBy)
    || (options.sortDesc != newOptions.sortDesc) ) {
    options = newOptions
    fetch()
  }
}

fetch()


return { __sfc: true,props, headers, options, storeUploads, total, timestampToDisplayString, getSortIndex, fetch, updateOptions }
}

})